<div *ngIf="isDataLoaded" class="dialog-container" style="position: relative">
  <form name="form" novalidate>
    <div *ngIf="isOwner_">
      <div *ngIf="!showInfo">
        <p style="font-weight: bolder; color: #7c7c7c">You can share your project with...</p>

        <table mat-table [dataSource]="dataTableSource">
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef>User</th>
            <td mat-cell *matCellDef="let model">{{ model.full_name }}</td>
          </ng-container>

          <ng-container matColumnDef="mail">
            <th mat-header-cell *matHeaderCellDef>E-Mail</th>
            <td mat-cell *matCellDef="let model">{{ model.email }}</td>
          </ng-container>

          <ng-container matColumnDef="toggle">
            <th mat-header-cell *matHeaderCellDef>Sharing</th>
            <td mat-cell *matCellDef="let model; let i = index">
              <mat-slide-toggle
                [checked]="model.role!=null"
                [disabled]="disableSharing"
                (change)="toggleSharing($event, model)"
              ></mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="rights">
            <th mat-header-cell *matHeaderCellDef style="text-align: center; padding-bottom: 6px">
              User rights
              <mat-icon
                tooltip="With 'View' rights a contact can only view project content and has no access to functionalities like 'Change CAD' and 'Changes'. With 'Edit' rights a contact can edit project content and has access to all functionalities."
                style="color: #21a0d2"
              >
                contact_support
              </mat-icon>
            </th>
            <td mat-cell *matCellDef="let model; let i = index">
              <div class="col-12" *ngIf="users_roles[model.username] !== 'owner'"> <!--no need for this check?(AS)-->
                <button
                  mat-button
                  class="btn btn-sm"
                  (click)="changeRole(model, 'reader')"
                  style="border-radius: 15px 0 0 15px; line-height: normal"
                  [disabled]="model.role == null"
                  [ngClass]="model.role === 'reader' ? 'share-button' : 'share-button-reverse'"
                >
                  View
                </button>
                <button
                  mat-button
                  class="btn btn-sm"
                  (click)="changeRole(model, 'reviewer')"
                  style="border-radius: 0 15px 15px 0; line-height: normal"
                  [disabled]="model.role == null"
                  [ngClass]="model.role === 'reviewer' ? 'share-button' : 'share-button-reverse'"
                >
                  Edit
                </button>
              </div>

              <div class="col-12 text-center" *ngIf="model.role === 'owner'"> <!--required?(AS)-->
                <button
                  mat-button
                  class="btn btn-sm share-button-reverse"
                  style="border-radius: 15px; line-height: normal"
                >
                  OWNER
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="curveColumnsTable"></tr>
          <tr mat-row *matRowDef="let row; columns: curveColumnsTable"></tr>
        </table>
      </div>

      <p *ngIf="showInfo" style="margin-top: 15px">
        No contacts available. Add contacts
        <span><a routerLink="app/contacts" (click)="close()">here.</a></span>
      </p>

      <div class="row align-input">
        <div class="col-9">
          <form style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label style="color: #7c7c7c">Invite a new user</mat-label>
              <input
                matInput
                placeholder="E-Mail of person you want to grant access..."
                [(ngModel)]="email"
                name="email"
              />
            </mat-form-field>
          </form>
        </div>

        <div class="col-3">
          <button
            mat-raised-button
            style="background-color: #21a0d2; color: white; margin-top: 10px"
            tooltip="Add user..."
            type="button"
            (click)="inviteUser()"
          >
            Invite
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="!isOwner_" class="ml-4 mt-3" style="text-align: center; color: #373737">
      <p>Project owner: {{ project.created_by }}</p>
      <p>I want to stop participating on this project.</p>
      <button mat-button class="btn btn-sm share-button" style="width: 200px" (click)="endParticipation()">
        End participation
      </button>
    </div>
  </form>
</div>
